<template>
  <div class="main-container">
    <div class="users-list">
      <div class="chat-sidebar-channel scroller">
        <tab-nav
          :pills="true"
          :vertical="true"
          class="iq-chat-ui"
          id="chat-list-data"
        >
          <span v-for="user in users" :key="user.id">
            <li>
              <button class="chat-item" id="myTab" role="tab">
                <ChatItem :user="user" @userClicked="getUserMessages" />
              </button>
            </li>
          </span>
        </tab-nav>
      </div>
    </div>
    <div class="col-lg-9 chat-data p-0 chat-data-right background-container">
      <tab-content id="v-pills-tabContent">
        <tab-content-item
          :active="true"
          id="chatbox"
          aria-labelled-by="v-pills-default"
        >
          <template v-if="selectedUser">
            <div class="chat-head background-container">
              <header>
                <img
                  :src="selectedUser.profilePic"
                  alt="avatar"
                  class="avatar-50 rounded"
                />
                <h4 class="header-user-name">
                  {{ selectedUser.firstName }}
                  {{ selectedUser.lastName }}
                </h4>
              </header>
            </div>
            <div class="chat-content scroller background-container">
              <span v-for="message in messages" :key="message.id">
                <div class="chat">
                  <div class="chat-detail">
                    <span class="chat-time mt-1">
                      {{ message.timestamp.toDate().toLocaleDateString() }}
                    </span>
                    <div class="message-user-photo">
                      <div class="chat-message">
                        <p>{{ message.messageBody }}</p>
                      </div>
                      <div class="chat-user">
                        <a class="avatar m-0">
                          <img
                            :src="doctor.profilePic"
                            alt="avatar"
                            class="avatar-35 rounded"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            <div class="chat-footer p-3 bg-white">
              <form
                class="d-flex align-items-center"
                @submit.prevent="handleSubmit"
              >
                <input
                  type="text"
                  class="form-control mr-3"
                  placeholder="Type your message"
                  v-model="newMessage"
                />
                <button
                  type="submit"
                  class="btn btn-primary d-flex align-items-center p-2"
                >
                  <i class="fas fa-paper-plane" aria-hidden="true"></i>
                  <span class="d-none d-lg-block ml-1">Send</span>
                </button>
              </form>
            </div>
          </template>
          <div class="default-chatbox" v-else>
            <h4>Click on a user to start a conversation!</h4>
          </div>
        </tab-content-item>
      </tab-content>
    </div>
  </div>
</template>

<script>
import { xray } from "../../../config/pluginInit";
import ChatItem from "../../../components/Chat/ChatItem";
import ToggleButton from "../../../components/Chat/ToggleButton";
import ToggleContent from "../../../components/Chat/ToggleContent";
import getUsers from "../../../composables/getUsers";
import getMessages from "../../../composables/getMessages";
import getDoctor from "../../../composables/getDoctor";
import { ref } from "vue";

export default {
  name: "ChatIndex",
  components: { ChatItem, ToggleButton, ToggleContent },
  setup() {
    const { users, error, loadUsers } = getUsers();
    const { messages, loadUserMessages, addUserMessage } = getMessages();
    const { doctor, loadDoctor } = getDoctor();
    const selectedUser = ref(null);
    const userIsActive = ref(null);
    const newMessage = ref("");

    loadDoctor();
    loadUsers();

    const getUserMessages = (user) => {
      selectedUser.value = user;
      loadUserMessages(user.id);
    };

    const handleSubmit = () => {
      addUserMessage(selectedUser.value.id, newMessage.value);
      newMessage.value = "";
    };

    return {
      users,
      error,
      messages,
      getUserMessages,
      userIsActive,
      selectedUser,
      newMessage,
      handleSubmit,
      doctor,
    };
  },
  mounted() {
    xray.index();
  },
};
</script>

<style>
.remove-toggle::after {
  content: unset;
}
.chat-item {
  background-color: var(--container-color);
  border: none;
  width: 100%;
  border-radius: 10px !important;
  padding: 10px !important;
  margin-bottom: 15px !important;
}
.chat-item:focus {
  background-color: #9e87a1;
}
.default-chatbox {
  width: 100%;
  height: 100%;
  background-color: #9e87a1;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.message-user-photo {
  display: flex;
  align-items: center;
  margin: 0.5rem 0.5rem 1.5rem;
  align-self: flex-end;
}
.header-user-name {
  margin-left: 15px !important;
}
</style>
